{
  "termsInfo": "<strong>Updates to Terms of Use.</strong> See the updates <2>here</2>.",
  "privacyInfo": "<strong>Updates to Privacy Notice.</strong> See the updates <2>here</2>."
}
